/* eslint-disable */

(function($) {

  'use strict';

  function Popup() {

    var self = this,
      $el = null,

      options = {
        'example': null
      };

    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        // Fix for Safari unable to set max-height in %
        if (Modernizr.touchevents) {
          // alert('mobile');
          $('.js-popup-content').css({'max-height' : $(window).height()});
        } else {
          $('.js-popup-content').css({'max-height' : ''});
        }
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // console.log('Popup');

      // Caching
      $el = options.$el;

      // Close popup
      $('.js-close-popup').click(function() {
        var $popup = $(this).closest('.popup');

        $popup.removeClass('is-active');
        $popup.find('.js-popup-overlay').removeClass('is-active');
      });

      // Open popup
      $('.js-open-popup').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this),
            $popup = $('.js-popup[data-popup="' + $this.data('popup') + '"]');

        if ($popup.length === 0) console.info('Popup not found');

        $popup.find('.js-popup-overlay').addClass('is-active');

        $popup.addClass('is-active');

        if ($('html').hasClass('touchevents')) {
          $('html, body').animate({scrollTop : 0}, 500);
        }

      });

      //*************
      window.cache.$window.on('resize', Utils.debounce(onResize, 400));
      onResize();     // initial call on load
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Popup = Popup;

}(jQuery));
